<template>
  <div class="bg-white flex items-center w-full h-full">
    <nav v-if="!isInFrame()" class="w-full relative cursor-pointer group z-10 xl:flex hidden">
      <ul class="flex items-center h-full w-full xl:gap-6 xl:justify-start justify-between mr-3 xl:mr-0">
        <li class="border-background last:border-none hover:text-secondary">
          <router-link
            class="text--md font-bold"
            :class="{
              'text-secondary-pressed': $route.name === '/how-it-works',
            }"
            :to="{ name: '/how-it-works' }"
          >
            {{ $t("how-it-works-page.title") }}
          </router-link>
        </li>
        <li class="border-background last:border-none hover:text-secondary">
          <router-link
            class="text--md font-bold"
            :class="{
              'text-secondary-pressed': $route.name === '/programs',
            }"
            :to="{ name: '/programs' }"
          >
            {{ $t("common.workshops") }}
          </router-link>
        </li>
        <li class="border-background last:border-none hover:text-secondary">
          <router-link
            class="text--md font-bold"
            :class="{
              'text-secondary-pressed': $route.name === '/about',
            }"
            :to="{ name: '/about' }"
          >
            {{ $t("common.about-us") }}
          </router-link>
        </li>
        <li class="border-background last:border-none hover:text-secondary">
          <router-link
            class="text--md font-bold"
            :class="{
              'text-secondary-pressed': $route.name === '/contacts',
            }"
            :to="{ name: '/contacts' }"
          >
            {{ $t("common.contact-us") }}
          </router-link>
        </li>
      </ul>
    </nav>

    <div class="flex items-center gap-2 xl:gap-6 ml-[auto]">
      <HeaderCart />
      <HeaderProfileList v-if="!isInFrame()" />
      <LocalesSwitcher list-position="left" />
    </div>
  </div>
</template>

<script setup>
import { isInFrame } from "@academy/utils"

import LocalesSwitcher from "@/components/LocalesSwitcher.vue"
import HeaderCart from "@/components/header/header-nav/HeaderCart.vue"
import HeaderProfileList from "@/components/header/header-nav/HeaderProfilesList.vue"

defineEmits({
  "open-partner-form": null,
})
</script>

<style lang="scss" scoped>
.active {
  @apply text-secondary-pressed;
}
</style>
